module.exports = __webpack_public_path__ + "img/equal_housing.f9d82c7.jpg";